import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CardStep from './components/CardStep'

const MultipleSteps = ({ steps, setIsReady }) => {
    const [allSteps, setAllSteps] = useState(
        steps?.map((step, index) => ({ ...step, id: index })),
    )
    const [currentStep, setCurrentStep] = useState(0)

    const onCardClick = step => {
        setCurrentStep(step)
    }

    const goToNextStep = () => {
        const nextStep = allSteps?.find(
            step => step?.id === currentStep?.id + 1,
        )
        if (nextStep) {
            setCurrentStep(nextStep)
        } else {
            setIsReady(true)
        }
    }

    const stepReady = () => {
        const stepReady = { ...currentStep, ready: true }
        setCurrentStep(stepReady)
        setAllSteps(
            allSteps?.map(step =>
                step?.id === currentStep?.id ? stepReady : step,
            ),
        )
        goToNextStep()
    }

    const stepIsNotReady = () => {
        const stepNoReady = { ...currentStep, ready: false }
        setCurrentStep(stepNoReady)
        setAllSteps(
            allSteps?.map(step =>
                step?.id === currentStep?.id ? stepNoReady : step,
            ),
        )
    }

    return (
        <div className="flex flex-col items-start justify-start w-full">
            {allSteps.map(step => {
                const isActive = currentStep?.id === step?.id
                return (
                    <CardStep
                        onStepIsNotReady={stepIsNotReady}
                        onStepReady={stepReady}
                        key={step?.title}
                        onCardClick={() => onCardClick(step)}
                        {...step}
                        active={isActive}
                    />
                )
            })}
        </div>
    )
}

MultipleSteps.propTypes = {
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            subtitle: PropTypes.string,
            ready: PropTypes.bool,
            content: PropTypes.node,
        }),
    ).isRequired,
    isReady: PropTypes.bool,
    setIsReady: PropTypes.func,
}

export default MultipleSteps
